import routes from './routes';
import accounts from './accounts';
import * as menus from './menus';
import shares from './shares';

const configs = {
    routes,
    accounts,
    menus,
    shares,
};

export default configs;
